import { Link, Typography } from '@mui/material';

const year = new Date().getFullYear();

interface CopyrightProps {
  yearSecondLine?: boolean;
  isSidebarOpen?: boolean;
}

const Copyright = ({ yearSecondLine, isSidebarOpen = true }: CopyrightProps) => (
  <Typography
    variant="body2"
    color="text.secondary"
    align="center"
    sx={{
      visibility: isSidebarOpen ? 'visible' : 'hidden',
    }}
  >
    <span>Copyright © </span>
    <Link color="inherit" href="https://www.arcosdorados.com/">
      Arcos Dorados
    </Link>
    {yearSecondLine && <br />}
    <span> {year}.</span>
  </Typography>
);

export default Copyright;
